<div class="flex flex-col px-4">
  <mat-divider class="!border-[#E7EAEE]" />

  <div class="flex gap-2 items-center">

    @if (specialData != null && specialData?.isAccessible) {
    <mot-button [icon]="specialData?.isCallNeeded ? 'wheelchair-move-phone' : 'wheelchair-move'"
      [text]="specialData?.isCallNeeded ? accessibleWithOrderText : accessibleText"
      [tooltip]="specialData?.isCallNeeded ? accessibleWithOrderTooltipText : accessibleTooltipText"
      ariaHaspopup="dialog" (onClick)="openAccissibleModal(); $event.stopPropagation()" />
    }

    @if (specialData != null && specialData?.isFlexible) {
    <mot-button [icon]="'phone'" [text]="flexibleText" [tooltip]="flexibleTooltipText" ariaHaspopup="dialog"
      (onClick)="openFlexibleModal(false); $event.stopPropagation()" />
    }

    @if (specialData != null && specialData?.isOrderInAdvanced) {
    <mot-button [icon]="'phone'" [text]="reserveInAdvancedText" ariaHaspopup="dialog"
      (onClick)="openFlexibleModal(true); $event.stopPropagation()" />
    }
    @if (showSpecialMessagesButton) {
    <div class="flex items-center">
      <mot-button [icon]="'message-exclamation'" [text]="specialMessagesText" [ariaLabel]="specialMessagesAriaLabel"
        ariaHaspopup="dialog" (onClick)="openSpecialMessages(); $event.stopPropagation()" />
      <app-special-messages-counter [messagesCounter]="specialMessagesCounter" />
    </div>
    }
  </div>
</div>